/*eslint-disable*/
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripVertical } from '@fortawesome/free-solid-svg-icons';

import {
    ListGroupItem,
    UncontrolledTooltip,
} from "reactstrap";
import './SingleRoadmapItem.scss';

import CommentsIcon from '../../../../assets/images/public/p-comments-icon.svg';
import SampleImg from '../../../../assets/images/public.jpg';

import UpvoteComponent from './UpvoteComponent';
import ItemStatus from './ItemStatus';

const SingleRoadmapItem = ({
    onRoadmapClick,
    roadmap,
    index,
    upvoteHandler,
    pageType,
    location,
}) => {
    const showFeedbackThumbnail = pageType === 'public-roadmap';
    return (

        <div className="roadmap-single-main" >
            {
                location === 'dashboard' && (
                    <div className="drag-handle" id="drag-handle">
                        <FontAwesomeIcon icon={faGripVertical} className="drag-handle-icon" />

                        <UncontrolledTooltip
                            placement="top"
                            target="drag-handle"
                        >
                            Drag to change status
                        </UncontrolledTooltip>
                    </div>
                )
            }
            <ListGroupItem
                onClick={() => onRoadmapClick(roadmap)}
                className="roadmap__item"
                key={index}
            >
                {/* upvote button */}
                <UpvoteComponent
                    upvoteHandler={upvoteHandler}
                    roadmap={roadmap}
                />
                {/* roadmap item content */}
                <div style={{ cursor: 'pointer' }} className="roadmap-item-content">
                    {
                        pageType !== 'public-roadmap' && (
                            <ItemStatus itemInfo={roadmap} />
                        )
                    }
                    {
                        (showFeedbackThumbnail && roadmap.thumbnail) && (
                            <div className="roadmap-thumbnail">
                                <img src={roadmap.thumbnail} alt="thumbnail" style={{ width: '100%', objectFit: 'cover', borderRadius: '10px', marginBottom: '10px' }} />
                            </div>
                        )
                    }
                    <p className="roadmap-title">{roadmap.title}</p>
                    <p className={`req-description`} >{roadmap.description}</p>
                    <div style={{ marginBottom: 0, lineHeight: 1.1 }}>

                        {(roadmap.category_emoji && roadmap.category) && (
                            <span className="category-emoji">{roadmap.category_emoji}</span>
                        )}
                        <span className="category__text">
                            {roadmap.category}
                        </span>
                        {
                            roadmap.activity?.length > 0 && (
                                <div className="comments-overview">
                                    <img src={CommentsIcon} alt="comments" className="comments-icon" />
                                    {roadmap.activity?.length}
                                </div>
                            )
                        }
                    </div>
                </div>
            </ListGroupItem>
        </div>

    );
};

export default SingleRoadmapItem;
